import { render, staticRenderFns } from "./SetupStep01.vue?vue&type=template&id=4d0ad850&scoped=true&"
import script from "./SetupStep01.vue?vue&type=script&lang=js&"
export * from "./SetupStep01.vue?vue&type=script&lang=js&"
import style0 from "./SetupStep01.vue?vue&type=style&index=0&id=4d0ad850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0ad850",
  null
  
)

export default component.exports